import React, { Fragment, useState } from 'react';
import ReactLoading from 'react-loading';
// Styles
import './Loading.css';

const Loading = () => {
    return (
        <section className="io-loading">
            <ReactLoading type="spinningBubbles" color="#cf4500" height={100} width={100} />
        </section>
    );
}

export default Loading;
